import React, {Component} from 'react';
import EditContractView from "./EditBilateralContractView";
import {Growl} from "primereact/growl";
import {withoutComma} from "../../../../utils/calculate/Amount";
import {BilateralContractService} from "../../../../service/bilateral/contract/BilateralContractService";
import PropTypes from "prop-types";
import {CloseSystemService} from "../../../../service/support/CloseSystemService";

export default class EditBilateralContractContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables
     * se llaman los catálogos para llenar los dropdown.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.bilateralContractService = new BilateralContractService();
        this.closeSystemService = new CloseSystemService();

        this.state = {
            returnPath: this.props.location.state.returnPath,
            dataContract: this.props.location.state.contractSelected,
            isLoading: false,
            isClosed: false,
        };

        this.handleChangeValue = this.handleChangeValue.bind(this);
        this.returnBilateralContractPage = this.returnBilateralContractPage.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.validateIfIsCloseSystem = this.validateIfIsCloseSystem.bind(this);
        this.isValidCapacity = this.isValidCapacity.bind(this);
        this.isValidThreshold = this.isValidThreshold.bind(this);
        this.validResponse = this.validResponse.bind(this);
        this.loading = this.loading.bind(this);
    }
    componentDidMount() {
        if (this.isExistentContract(this.state.dataContract.id)) {
            this.validateIfIsCloseSystem();
        } else {
            this.setState({isClosed: true,})
        }
    }

    isExistentContract(contractId) {
        return contractId !== 0;
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(opt) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: opt || false,
            });
        }
    }

    /**
     * Función que valida si el sistema está cerrado para editar las variables
     * **/
    validateIfIsCloseSystem() {
        this.loading(true);
        this.closeSystemService.isCloseSystem().then(data => {
            if(data !== undefined) {
                let isClosedAux = data.closed === undefined ? false : Boolean(data.closed);
                if (!isClosedAux) {
                    this.growl.show({
                        severity: 'info', summary: 'Info.',
                        detail: 'No es posible editar la configuración del Contrato Bilateral, mientras el sistema se encuentre abierto'
                    });
                }
                this.setState({
                    isClosed: isClosedAux,
                });
            }
            this.loading(false);
        });
    }

    /**
     * Función  que maneja el cambio de valor en los dropdown y en los campos de texto
     * Debido a que el campo dropdown, maneja un objeto. Hace esa conversión para
     * colocar el valor en el objeto a editar.
     * También valida que los campos numéricos sólo acepten x números enteros
     * y dos decimales. El número de enteros a manejar, se indica en el atributo id
     * del campo.
     * @param event
     */
    handleChangeValue(event) {
        const {name, value} = event.target;
        let dataContractAux = this.state.dataContract;
        dataContractAux[name]=value;
        this.setState({dataContract: dataContractAux,})
    }

    /**
     * Función que consume a ContractOTCService donde guarda los cambios que se hicieron
     * en la vista, sobre el elemento.
     * Hace tres validaciones antes de guardar el elemento.
     */
    saveChanges() {
        let isValidData = this.isValidCapacity(this.state.dataContract.haircut) &&
            this.isValidThreshold(this.state.dataContract.threshold, this.state.dataContract.usedThreshold);

        if (isValidData) {
            this.loading(true);
            if (this.state.dataContract.id === 0){
                this.bilateralContractService.createBilateralContract(this.state.dataContract)
                    .then(resp => { this.validResponse(resp); });
            } else {
                this.bilateralContractService.editBilateralContract(this.state.dataContract)
                    .then(resp => { this.validResponse(resp); });
            }
        }
    }

    validResponse (res){
        if (res.status!== 200){
            this.growl.show({sticky: true, severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
        } else {
            let message = {
                severity: 'success',
                summary: 'Éxito',
                detail: 'El registro ha sido editado correctamente',
            };
            this.returnBilateralContractPage(message);
        }
        this.loading(false);
    }

    isValidCapacity(capacityAux){
        let valid = true,
            capacity = Number(withoutComma(capacityAux));
        if (capacity === undefined || capacityAux === "") {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Llenar correctamente los campos requeridos'
            });
            valid = false;
        } else if (capacity > 100) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'El aforo no puede ser mayor a 100.0000'
            });
            valid = false;
        }
        return valid;
    }

    isValidThreshold(thresholdAux, usedThresholdAux) {
        let valid = true,
            threshold = Number(withoutComma(thresholdAux)),
            usedThreshold = Number(withoutComma(usedThresholdAux));
        if (threshold === undefined || thresholdAux === "") {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Llenar correctamente los campos requeridos'
            });
            valid = false;
        } else if (threshold > 99999999999) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'La línea de crédito no puede ser mayor a 99,999,999,999.00'
            });
            valid = false;
        } else if (threshold < usedThreshold) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'La línea de crédito no puede ser menor, de la línea utilizada.'
            });
            valid = false;
        }
        return valid;
    }

    /**
     * Función que regresa a la pantalla de Contrato Bilateral
     */
    returnBilateralContractPage(message) {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        return (
            <EditContractView
                              dataContract={this.state.dataContract}
                              isLoading={this.state.isLoading}
                              isClosed={this.state.isClosed}
                              saveChanges={this.saveChanges}
                              returnBilateralContractPage={this.returnBilateralContractPage}
                              handleChangeValue={this.handleChangeValue}
                              messagesGrowl={messagesGrowl}
            />
        );
    }
}

EditBilateralContractContainer.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
};
